import { uuidPattern } from "./patterns";

export function isUUID(uuid: string): Boolean {
  return uuidPattern.test(uuid);
}

export type UUID = string;
